import { render, staticRenderFns } from "./PreguntaFrecuentesPTP.vue?vue&type=template&id=e57253e8"
import script from "./PreguntaFrecuentesPTP.vue?vue&type=script&lang=js"
export * from "./PreguntaFrecuentesPTP.vue?vue&type=script&lang=js"
import style0 from "./PreguntaFrecuentesPTP.vue?vue&type=style&index=0&id=e57253e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports